import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/home', // 首页
      name: 'Home',
      meta: {
        title: '首页',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/home/index')
    }, {
      path: '/leaseGuide',
      name: 'LeaseGuide',
      meta: {
        title: '政策资讯',
        keepAlive: true // 不需要缓存
      },
      component: () => import('@/pages/leaseGuide/index')
    }, {
      path: '/leaseGuide/detail',
      name: 'LeaseGuideDetail',
      meta: {
        title: '政策资讯详情',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/leaseGuide/detail')
    }, {
      path: '/leaseGuide/more',
      name: 'LeaseGuideMore',
      meta: {
        title: '政策资讯更多',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/leaseGuide/more')
    }, {
      path: '/informationPerfection/personal/index',
      name: 'personalIndex',
      meta: {
        title: '房东、租客信息完善',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/informationPerfection/personal/index')
    }, {
      path: '/informationPerfection/organize/index',
      name: 'organizeIndex',
      meta: {
        title: '机构、企业信息完善',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/informationPerfection/organize/index')
    }, {
      path: '/informationPerfection/personalIndex',
      name: 'personalIndex',
      meta: {
        title: '个人信息完善',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/informationPerfection/personalIndex')
    }, {
      path: '/informationPerfection/organizeIndex',
      name: 'organizeIndex',
      meta: {
        title: '机构信息完善',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/informationPerfection/organizeIndex')
    },
    {
      path: '/signCenter',//签约中心
      name: 'SignCenter',
      meta: {
        title: '签约中心',
        keepAlive: true
      },
      component: () => import('@/pages/signCenter/index')
    },
    {
      path: '/signCenterAdd',//签约中心-新增、编辑
      name: 'SignCenterAdd',
      meta: {
        title: '选择房源',
        keepAlive: false
      },
      component: () => import('@/pages/signCenter/add/index')
    },
    {
      path: '/changeContract',//签约中心-变更
      name: 'ChangeContract',
      meta: {
        title: '变更',
        keepAlive: false
      },
      component: () => import('@/pages/signCenter/change/index')
    },
    {
      path: '/keepContract',//签约中心-续约
      name: 'KeepContract',
      meta: {
        title: '续约',
        keepAlive: false
      },
      component: () => import('@/pages/signCenter/keepContract/index')
    },
    {
      path: '/cancellationContract',//签约中心-注销
      name: 'CancellationContract',
      meta: {
        title: '注销',
        keepAlive: false
      },
      component: () => import('@/pages/signCenter/cancellation/index')
    },
    {
      path: '/signProgress',//签约中心-进度查询
      name: 'SignProgress',
      meta: {
        title: '签约进度',
        keepAlive: false
      },
      component: () => import('@/pages/signCenter/signProgress')
    },
    {
      path: '/signIframe',//签约中心-签署
      name: 'SignIframe',
      meta: {
        title: '签约签署',
        keepAlive: false
      },
      component: () => import('@/pages/signCenter/signIframe')
    },
    {
      path: '/signCenterDetail',//签约中心-详情页
      name: 'SignCenterDetail',
      meta: {
        title: '签约详情',
        keepAlive: false
      },
      component: () => import('@/pages/signCenter/detail')
    },
    {
      path: '/signCenterWX',
      name: 'SignCenterWX',
      meta: {
        title: '签约签署',
        keepAlive: true
      },
      component: () => import('@/pages/signCenterWX/index')
    },
    {
      path: '/message',//房源维护
      name: 'Message',
      meta: {
        title: '消息提示',
        keepAlive: true,
        apartmentType: ''
      },
      component: () => import('@/pages/message/list/index')
    },
    {
      path: '/message/detail',//房源维护
      name: 'MessageDetail',
      meta: {
        title: '消息提示',
        keepAlive: false,
        apartmentType: ''
      },
      component: () => import('@/pages/message/detail/index')
    },
    {
      path: '/houseMaintenance',//房源维护
      name: 'HouseMaintenance',
      meta: {
        title: '房源维护',
        keepAlive: true,
        apartmentType: ''
      },
      component: () => import('@/pages/houseMaintenance/index')
    },
    {
      path: '/houseView',//房源维护
      name: 'HouseView',
      meta: {
        title: '房源维护',
        keepAlive: false,
        apartmentType: ''
      },
      component: () => import('@/pages/houseMaintenance/view/index')
    },
    {
      path: '/codes', //编码详情
      name: 'Codes',
      meta: {
        title: '编码详情',
        keepAlive: false,
        apartmentType: ''
      },
      component: () => import('@/pages/houseMaintenance/codes/index')
    },
    {
      path: '/houseMaintenanceConcentre',//房源维护-集中式房源管理
      name: 'HouseMaintenanceConcentre',
      meta: {
        title: '房源维护-集中式房源管理',
        keepAlive: true,
        apartmentType: '10'
      },
      component: () => import('@/pages/houseMaintenance/index')
    },
    {
      path: '/houseMaintenanceDecentre',//房源维护-分散式房源管理
      name: 'HouseMaintenanceDecentre',
      meta: {
        title: '房源维护-分散式房源管理',
        keepAlive: true,
        apartmentType: '20'
      },
      component: () => import('@/pages/houseMaintenance/index')
    },
    /*    {
          path: '/houseMaintenanceDetail',//房源详情
          name: 'HouseMaintenanceDetail',
          meta: {
            title: '房源详情',
            keepAlive: false
          },
          component: () => import('@/pages/houseMaintenance/detail')
        },*/
    {
      path: '/pc/houseDet',//房屋详情
      name: 'HouseDetail',
      meta: {
        title: '房屋详情',
        keepAlive: false
      },
      component: () => import('@/pages/pc/houseDet')
    }, {
      path: '/pc/recordDet',//房屋详情
      name: 'RecordDetail',
      meta: {
        title: '备案详情',
        keepAlive: false
      },
      component: () => import('@/pages/pc/recordDet')
    },
    {
      path: '/houseCreate', // 新建房源
      name: 'HouseCreate',
      meta: {
        title: '新建房源',
        keepAlive: false
      },
      component: () => import('@/pages/houseMaintenance/add/index')
    },
    {
      path: '/chooseHouse', // 选择房源
      name: 'ChooseHouse',
      meta: {
        title: '选择房源',
        keepAlive: false
      },
      component: () => import('@/pages/houseMaintenance/release/chooseHouse')
    },
    {
      path: '/releaseHouse', // 发布房源
      name: 'ReleaseHouse',
      meta: {
        title: '发布房源',
        keepAlive: false
      },
      component: () => import('@/pages/houseMaintenance/release/releaseHouse')
    },
    {
      path: '/releaseHouse/selectLnstitutions', // 发布房源 选择机构
      name: 'ReleaseHouseSelectLnstitutions',
      meta: {
        title: '选择机构',
        keepAlive: false
      },
      component: () => import('@/pages/houseMaintenance/components/selectLnstitutions')
    },
    {
      path: '/releaseHouse/selectEmployees', // 发布房源 选择从业人员
      name: 'ReleaseHouseSelectEmployees',
      meta: {
        title: '选择从业人员',
        keepAlive: false
      },
      component: () => import('@/pages/houseMaintenance/components/selectEmployees')
    },
    {
      path: '/filingCenter', //备案中心
      name: 'FilingCenter',
      meta: {
        title: '备案中心',
        keepAlive: true
      },
      component: () => import('@/pages/filingCenter/index')
    },
    {
      // filingCenterCopy
      path: '/filingCenterCopy',
      name: 'FilingCenterCopy',
      meta: {
        title: '备案中心',
        keepAlive: true
      },
      component: () => import('@/pages/filingCenterCopy/index')
    },
    {
      path: '/filingCenterIframe', //备案中心签署
      name: 'FilingCenterIframe',
      meta: {
        title: '备案签署',
        keepAlive: false
      },
      component: () => import('@/pages/filingCenter/filingCenterIframe')
    },
    {
      path: '/filingCenter/change', //改变备案
      name: 'Changefiling',
      meta: {
        title: '我要变更',
        keepAlive: false
      },
      component: () => import('@/pages/filingCenter/change/index')
    },
    {
      path: '/filingCenter/cancellation', //注销备案
      name: 'FilingCancellation',
      meta: {
        title: '我要注销',
        keepAlive: false
      },
      component: () => import('@/pages/filingCenter/cancellation/index')
    },
    {
      path: '/filingCenter/add', //添加备案
      name: 'addCancellation',
      meta: {
        title: '我要备案',
        keepAlive: false
      },
      component: () => import('@/pages/filingCenter/add/index')
    },
    {
      path: '/filingCenter/appraise', //评价
      name: 'FilingAppraise',
      meta: {
        title: '评价',
        keepAlive: false
      },
      component: () => import('@/pages/filingCenter/appraise')
    },
    // filingProgress
    {
      path: '/filingCenter/filingProgress', //添加备案
      name: 'FilingProgress',
      meta: {
        title: '签署详情',
        keepAlive: false
      },
      component: () => import('@/pages/filingCenter/filingProgress')
    },
    {
      path: '/filingCenter/filingCertificate', //备案证明
      name: 'FilingCertificate',
      meta: {
        title: '备案证明',
        keepAlive: false
      },
      component: () => import('@/pages/filingCenter/filingCertificate')
    },
    {
      path: '/onlineSignatureFiling', //我的网签备案
      name: 'OnlineSignatureFiling',
      meta: {
        title: '我的网签备案',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/index')
    },
    {
      path: '/onlineSignatureFiling/refundDetail', //我的网签备案
      name: 'refundDetail',
      meta: {
        title: '退款详情',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/refundDetail')
    },
    {
      path: '/onlineSignatureFiling/refundScheme', //我的网签备案
      name: 'refundScheme',
      meta: {
        title: '退款详情',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/refundScheme')
    },
    {
      path: '/onlineSignatureFiling/judgmentScheme', //我的网签备案
      name: 'judgmentScheme',
      meta: {
        title: '协会判定方案',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/judgmentScheme')
    },
    {
      path: '/onlineSignatureFiling/postpone', //我的网签备案
      name: 'postpone',
      meta: {
        title: '延期',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/postpone')
    },
    {
      path: '/onlineSignatureFiling/giveBack', //我的网签备案
      name: 'giveBack',
      meta: {
        title: '交还',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/giveBack')
    },
    {
      path: '/onlineSignatureFiling/resideRegister', //我的网签备案
      name: 'resideRegister',
      meta: {
        title: '居住登记',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/resideRegister')
    },
    {
      path: '/onlineSignatureFiling/deliver', //我的网签备案
      name: 'deliver',
      meta: {
        title: '交付',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/deliver')
    },
    {
      path: '/onlineSignatureFiling/appraise', //我的网签备案
      name: 'appraise',
      meta: {
        title: '评价',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/appraise')
    },
    {
      path: '/onlineSignatureFiling/deposit', //我的网签备案
      name: 'deposit',
      meta: {
        title: '待交存',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/deposit')
    },
    {
      path: '/onlineSignatureFiling/delivered/index', //我的网签备案
      name: 'undelivered',
      meta: {
        title: '未交付',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/delivered/index')
    },
    {
      path: '/onlineSignatureFiling/delivered/detail', //我的网签备案
      name: 'deliveredDetail',
      meta: {
        title: '已交付',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/delivered/detail')
    }, {
      path: '/onlineSignatureFiling/giveBack/index', //我的网签备案
      name: 'giveBackIndex',
      meta: {
        title: '未交还',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/giveBack/index')
    },
    {
      path: '/onlineSignatureFiling/giveBack/detail', //我的网签备案
      name: 'giveBackDetail',
      meta: {
        title: '已交还',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/giveBack/detail')
    },
    {
      path: '/consultingComplaints/suggestions', //意见建议
      name: 'suggestions',
      meta: {
        title: '意见建议',
        keepAlive: false
      },
      component: () => import('@/pages/consultingComplaints/suggestions')
    },
    {
      path: '/consultingComplaints/myComplaint', //我的投诉   addComplaint
      name: 'myComplaint',
      meta: {
        title: '我的投诉',
        keepAlive: false
      },
      component: () => import('@/pages/consultingComplaints/myComplaint')
    },
    {
      path: '/consultingComplaints/complaintDetails', //投诉举报
      name: 'complaintDetails',
      meta: {
        title: '投诉举报',
        keepAlive: false
      },
      component: () => import('@/pages/consultingComplaints/complaintDetails')
    },
    {
      path: '/consultingComplaints/selectLnstitutions', //选取从业机构
      name: 'selectLnstitutions',
      meta: {
        title: '选取从业机构',
        keepAlive: false
      },
      component: () => import('@/pages/consultingComplaints/component/selectLnstitutions')
    },
    {
      path: '/consultingComplaints/selectEmployees', //选取从业人员
      name: 'selectEmployees',
      meta: {
        title: '选取从业人员',
        keepAlive: false
      },
      component: () => import('@/pages/consultingComplaints/component/selectEmployees')
    },
    {
      path: '/consultingComplaints/addComplaint', //新建投诉
      name: 'addComplaint',
      meta: {
        title: '新建投诉',
        keepAlive: true
      },
      component: () => import('@/pages/consultingComplaints/addComplaint')
    },
    {
      path: '/',//登录页
      name: 'Login',
      meta: {
        title: '登录页',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/login')
    },
    {
      path: '/choose',//登录页
      name: 'Choose',
      meta: {
        title: '选择角色',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/login/choose')
    },
    {
      path: '/chooseLegal',//登录页
      name: 'chooseLegal',
      meta: {
        title: '选择角色',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/login/choose')
    },
    {
      path: '/webview',//接收webview模式token
      name: 'webview',
      meta: {
        title: 'webview',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/login/webview')
    },
    {
      path: '/test',//登录页
      name: 'test',
      meta: {
        title: '上传',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/test')
    },
    {
      path: '/leaseBill/list/:type',
      name: 'leaseBill',
      meta: {
        title: '租赁账单(租客)',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/leaseBill')
    },
    {
      path: '/leaseBill/detail',
      name: 'leaseBillDet',
      meta: {
        title: '账单详情',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/leaseBill/detail')
    },
    {
      path: '/leaseBill/employed/billDetails',
      name: 'billDetails',
      meta: {
        title: '账单明细(租赁人员)',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/leaseBill/employed/billDetails')
    },
    {
      path: '/leaseBill/statistics',
      name: 'leaseBillStatic',
      meta: {
        title: '账单明细',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/leaseBill/statistics')
    },
    {
      path: '/leaseBill/employed',
      name: 'leaseBillEmp',
      meta: {
        title: '租赁账单',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/leaseBill/employed/index')
    },
    {
      path: '/leaseBill/employed/detail',
      name: 'leaseBillEmpDet',
      meta: {
        title: '租赁账单',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/leaseBill/employed/detail')
    },
    {
      path: '/leaseFilingQuery',//租赁备案查询
      name: 'LeaseFilingQuery',
      meta: {
        title: '租赁备案查询',
        keepAlive: true // 不需要缓存
      },
      component: () => import('@/pages/leaseFilingQuery/index')
    },
    {
      path: '/filingNoQuery',//备案编号查询
      name: 'FilingNoQuery',
      meta: {
        title: '备案编号查询',
        keepAlive: true // 不需要缓存
      },
      component: () => import('@/pages/filingNoQuery/index')
    },
    {
      path: '/rentManage',
      name: 'rentManage',
      meta: {
        title: '周边租金',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/rentManage/index')
    },
    {
      path: '/rentSearch',
      name: 'rentSearch',
      meta: {
        title: '租金查询',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/rentSearch/index')
    },
    {
      path: '/findHouse',
      name: 'findHouse',
      meta: {
        title: '地图查询',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/findHouse/index')
    },
    // 2022-3-11 09:25:17
    {
      path: '/realEstateError',
      name: 'RealEstateError',
      meta: {
        title: '楼盘字典纠错',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/realEstateError/index')
    },
    {
      path: '/errorCorrection',
      name: 'ErrorCorrection',
      meta: {
        title: '我要纠错',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/realEstateError/errorCorrection')
    },
    {
      path: '/realEstateDetail',
      name: 'RealEstateDetail',
      meta: {
        title: '详情',
        keepAlive: false // 不需要缓存
      },
      component: () => import('@/pages/realEstateError/detail')
    },
    // 2022-3-11 15:20:41
    {
      // 找中介机构
      // 找转租机构
      // 找中介
      path: '/employeesInstitutions',
      name: 'EmployeesInstitutions',
      meta: {
        title: '从业机构和人员查询',
        keepAlive: true
      },
      component: () => import('@/pages/EmployeesInstitutions')
    },
    {
      path: '/employeesInstitutions/information',
      name: 'Information',
      meta: {
        title: '机构详情',
        keepAlive: false
      },
      component: () => import('@/pages/EmployeesInstitutions/institutionsInformation')
    },
    // subleaseOrganization
    {
      path: '/employeesInstitutions/subleaseOrganization',
      name: 'SubleaseOrganization',
      meta: {
        title: '机构详情',
        keepAlive: false
      },
      component: () => import('@/pages/EmployeesInstitutions/subleaseOrganization')
    },
    {
      path: '/employeesInstitutions/branchInformation',
      name: 'BranchInformation',
      meta: {
        title: '分支机构详情',
        keepAlive: false
      },
      component: () => import('@/pages/EmployeesInstitutions/branchInformation')
    },
    {
      path: '/employeesInstitutions/personnelInformation',
      name: 'PersonnelInformation',
      meta: {
        title: '人员详情',
        keepAlive: false
      },
      component: () => import('@/pages/EmployeesInstitutions/personnelInformation')
    },
    {
      // IntermediaryBranch
      path: '/employeesInstitutions/IntermediaryBranch',
      name: 'IntermediaryBranch',
      meta: {
        title: '中介机构', //中介机构下的机构列表
        keepAlive: false
      },
      component: () => import('@/pages/EmployeesInstitutions/IntermediaryBranch')
    },
    // IntermediaryEmployees
    {
      // IntermediaryEmployees
      path: '/employeesInstitutions/IntermediaryEmployees',
      name: 'IntermediaryEmployees',
      meta: {
        title: '中介机构', //中介机构下的人员列表
        keepAlive: false
      },
      component: () => import('@/pages/EmployeesInstitutions/IntermediaryEmployees')
    },
    {
      path: '/myMassage',  //经济机构从业人员、租赁经营企业从业人员
      name: 'MyMassage',
      meta: {
        title: '我的信息',
        keepAlive: false
      },
      component: () => import('@/pages/myMessage')
    },
    {
      path: '/myEvaluate',  //经济机构从业人员、租赁经营企业从业人员
      name: 'myEvaluate',
      meta: {
        title: '我的评价',
        keepAlive: false
      },
      component: () => import('@/pages/myEvaluate')
    },
    {
      path: '/myProperty',  //经济机构从业人员、租赁经营企业从业人员
      name: 'myProperty',
      meta: {
        title: '物业交割',
        keepAlive: false
      },
      component: () => import('@/pages/myEvaluate')
    },
    {
      path: '/myReside',  //经济机构从业人员、租赁经营企业从业人员
      name: 'myReside',
      meta: {
        title: '居住人员登记',
        keepAlive: false
      },
      component: () => import('@/pages/myEvaluate')
    },
    {
      path: '/onlineSignatureFiling/backupDetail',  //经济机构从业人员、租赁经营企业从业人员
      name: 'backupDetail',
      meta: {
        title: '我的评价',
        keepAlive: false
      },
      component: () => import('@/pages/onlineSignatureFiling/backupDetail')
    },
    {
      path: '/mapComPageWX',  //小程序调用地图公共界面
      name: 'mapComPageWX',
      meta: {
        title: '微信地图',
        keepAlive: false
      },
      component: () => import('@/pages/mapComPageWX')
    },
    {
      path: '/recordReview',
      name: 'recordReview',
      meta: {
        title: '备案复核',
        keepAlive: false
      },
      component: () => import('@/pages/recordReview')
    },
    {
      path: '/recordReview/addRecordReview',
      name: 'addRecordReview',
      meta: {
        title: '备案复核新增',
        keepAlive: false
      },
      component: () => import('@/pages/recordReview/components/index.vue')
    },
    {
      path: '/recordReview/add',
      name: 'recordReviewAdd',
      meta: {
        title: '备案复核新增',
        keepAlive: false
      },
      component: () => import('@/pages/recordReview/components/First.vue')
    },
    {
      path: '/recordReview/Preview',
      name: 'recordReviewPreview',
      meta: {
        title: '备案复核预览',
        keepAlive: false
      },
      component: () => import('@/pages/recordReview/components/Preview.vue')
    },
    {
      path: '/recordReview/applyFor',
      name: 'recordReviewapplyFor',
      meta: {
        title: '备案复核审请',
        keepAlive: false
      },
      component: () => import('@/pages/recordReview/components/applyFor.vue')
    }
    //
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log(to);
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = Number(localStorage.scrollTop);
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js